export default __webpack_public_path__ + "static/media/Barbosa.0acca2c4.png";